import React, { Component } from 'react'
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';


const customTotal = (from, to, size) => (
  <span className="react-bootstrap-table-pagination-total">
    &nbsp;Prikazujem {from} do {to} od ukupno {size}
  </span>
);

export default class Grid extends Component {
  constructor(props) {
    super(props)
  }
  render() {
    return (
      <BootstrapTable
        keyField="rb"
        columns={this.props.columns}
        data={this.props.data}
        pagination={paginationFactory({
          showTotal: true,
          paginationTotalRenderer: customTotal
        })}
        striped={true}
      />
    )
  }
}
